import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_COMPONENT_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientComponentDetailsArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_COMPONENT_DETAILS } from '../redux/action-types'

const useUpdateIngredientComponentDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isComponentDetailsLoading, componentDetailsError } = useSelector(
    store => store.ingredients.ingredient,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_COMPONENT_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateIngredientComponentDetailsArgs(data),
        },
        dispatch,
        UPDATE_INGREDIENT_COMPONENT_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isComponentDetailsLoading,
      error: componentDetailsError,
    },
  ]
}

export default useUpdateIngredientComponentDetailsMutation
